var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSideNavContentFilter1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_1222",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_1222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6538 19.6538C16.7169 19.6538 15.925 19.3303 15.278 18.6835C14.6312 18.0365 14.3077 17.2446 14.3077 16.3078C14.3077 15.3708 14.6312 14.5788 15.278 13.932C15.925 13.285 16.7169 12.9615 17.6538 12.9615C18.5908 12.9615 19.3827 13.285 20.0295 13.932C20.6765 14.5788 21 15.3708 21 16.3078C21 17.2446 20.6765 18.0365 20.0295 18.6835C19.3827 19.3303 18.5908 19.6538 17.6538 19.6538ZM17.6528 18.1538C18.1624 18.1538 18.5977 17.9737 18.9587 17.6135C19.3196 17.2532 19.5 16.8183 19.5 16.3088C19.5 15.7991 19.3198 15.3638 18.9595 15.0028C18.5993 14.6419 18.1644 14.4615 17.6547 14.4615C17.1451 14.4615 16.7098 14.6417 16.349 15.002C15.9882 15.3622 15.8077 15.7971 15.8077 16.3068C15.8077 16.8164 15.9878 17.2517 16.348 17.6125C16.7083 17.9733 17.1433 18.1538 17.6528 18.1538ZM4.5 17.0578V15.5578H12.1155V17.0578H4.5ZM6.34625 11.0385C5.40925 11.0385 4.61733 10.715 3.9705 10.068C3.3235 9.42117 3 8.62925 3 7.69225C3 6.75542 3.3235 5.9635 3.9705 5.3165C4.61733 4.66967 5.40925 4.34625 6.34625 4.34625C7.28308 4.34625 8.075 4.66967 8.722 5.3165C9.36883 5.9635 9.69225 6.75542 9.69225 7.69225C9.69225 8.62925 9.36883 9.42117 8.722 10.068C8.075 10.715 7.28308 11.0385 6.34625 11.0385ZM6.34525 9.5385C6.85492 9.5385 7.29017 9.35834 7.651 8.998C8.01183 8.63784 8.19225 8.20292 8.19225 7.69325C8.19225 7.18359 8.01217 6.74834 7.652 6.3875C7.29167 6.02667 6.85675 5.84625 6.34725 5.84625C5.83758 5.84625 5.40225 6.02634 5.04125 6.3865C4.68042 6.74684 4.5 7.18175 4.5 7.69125C4.5 8.20092 4.68017 8.63625 5.0405 8.99725C5.40067 9.35809 5.83558 9.5385 6.34525 9.5385ZM11.8845 8.44225V6.94225H19.5V8.44225H11.8845Z",
    fill: "#0E0548"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideNavContentFilter1);
export default __webpack_public_path__ + "static/media/SideNavContentFilter1.9e7aa74fad3b0646a02f5b07b90db618.svg";
export { ForwardRef as ReactComponent };